// filepath: cryptobag-com/src/components/CryptoTableSkeleton.jsx
import React from 'react';

/**
 * CryptoTableSkeleton Component
 * Renders a skeleton loader that mimics the table structure.
 */
const CryptoTableSkeleton = () => {
  const headers = [
    { label: '#', className: "text-left" },
    { label: 'Token', className: "text-left" },
    { label: 'Price', className: "text-right" },
    { label: '24h %', className: "text-right" },
    { label: '7d %', className: "text-right" },
    { label: 'Market Cap', className: "text-right" },
    { label: 'Volume (24h)', className: "text-right" },
    { label: '7d Chart', className: "text-right pr-4" },
  ];

  const SkeletonRow = () => (
    <tr className="animate-pulse">
      <td className="px-4 py-4 whitespace-nowrap"><div className="h-4 bg-gray-700 rounded w-6"></div></td>
      <td className="px-2 py-4 whitespace-nowrap">
        <div className="flex items-center">
          <div className="h-8 w-8 bg-gray-700 rounded-full"></div>
          <div className="ml-3 space-y-2">
            <div className="h-4 bg-gray-700 rounded w-20"></div>
            <div className="h-3 bg-gray-700 rounded w-12"></div>
          </div>
        </div>
      </td>
      <td className="px-2 py-4 whitespace-nowrap text-right"><div className="h-4 bg-gray-700 rounded w-24 ml-auto"></div></td>
      <td className="px-2 py-4 whitespace-nowrap text-right"><div className="h-4 bg-gray-700 rounded w-16 ml-auto"></div></td>
      <td className="px-2 py-4 whitespace-nowrap text-right"><div className="h-4 bg-gray-700 rounded w-16 ml-auto"></div></td>
      <td className="px-2 py-4 whitespace-nowrap text-right"><div className="h-4 bg-gray-700 rounded w-28 ml-auto"></div></td>
      <td className="px-2 py-4 whitespace-nowrap text-right"><div className="h-4 bg-gray-700 rounded w-28 ml-auto"></div></td>
      <td className="px-4 py-4 whitespace-nowrap text-right"><div className="h-10 bg-gray-700 rounded w-28 ml-auto"></div></td>
    </tr>
  );

  return (
    // FIX: Apply sticky positioning to the container, not the thead
    <div className="overflow-x-auto shadow-2xl rounded-lg border border-gray-700/50 sticky top-[106px] z-20">
      <table className="min-w-full divide-y divide-gray-700/50 bg-gray-800">
        {/* FIX: Make thead sticky to the top of its parent container */}
        <thead className="bg-gray-900 sticky top-0 z-10">
          <tr>
            {headers.map((header) => (
              <th
                key={header.label}
                scope="col"
                className={`px-4 py-3 text-xs font-medium text-gray-400 uppercase tracking-wider ${header.className}`}
              >
                {header.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-700/50">
          {Array(15).fill(0).map((_, i) => <SkeletonRow key={i} />)}
        </tbody>
      </table>
    </div>
  );
};

export default CryptoTableSkeleton;